import React, { FC } from 'react'
import { styled } from '@creditas/stylitas'

import { SearchInput } from 'components/SearchInput'

import { StatusFilter } from './Status'

const Wrapper = styled.div`
  margin-top: 66px;
`

export const Filters: FC = () => {
  return (
    <Wrapper>
      <SearchInput />
      <StatusFilter />
    </Wrapper>
  )
}
